/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Infants_LabelInputs */

const en_guest_picker_infants_label = /** @type {(inputs: Guest_Picker_Infants_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infants`)
};

/**
* | output |
* | --- |
* | "Infants" |
*
* @param {Guest_Picker_Infants_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_infants_label = /** @type {((inputs?: Guest_Picker_Infants_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Infants_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_infants_label(inputs)
});